module.exports = {
          srcSet: __webpack_public_path__ + "public/images/aecc081aed3f429c947bf87604ca4c91-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/aecc081aed3f429c947bf87604ca4c91-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/aecc081aed3f429c947bf87604ca4c91-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/aecc081aed3f429c947bf87604ca4c91-1774.webp"},
          
          width: 1774,
          height: 887
        }